module.exports = __webpack_public_path__ + "fonts/Gotham-Black.e9c992fd.otf";